export default function SeasonStats() {
  const achievements = [
    {
      title: 'Most Wins',
      player: 'ShadowStrike',
      value: '892 Wins',
      icon: 'ri-trophy-line',
      color: 'text-yellow-400'
    },
    {
      title: 'Highest Win Rate',
      player: 'PhantomEdge',
      value: '86.2%',
      icon: 'ri-percent-line',
      color: 'text-green-400'
    },
    {
      title: 'Most Tournaments',
      player: 'RevenantKing',
      value: '47 Events',
      icon: 'ri-medal-line',
      color: 'text-purple-400'
    },
    {
      title: 'Longest Win Streak',
      player: 'BladeRunner',
      value: '23 Games',
      icon: 'ri-fire-line',
      color: 'text-orange-400'
    }
  ];

  const milestones = [
    {
      date: 'Dec 15, 2024',
      title: 'ShadowStrike reaches 15,000 points',
      description: 'First player to break the 15K barrier this season',
      icon: 'ri-star-line'
    },
    {
      date: 'Dec 10, 2024',
      title: 'PhantomEdge wins Winter Championship',
      description: 'Dominated the finals with a perfect 5-0 record',
      icon: 'ri-trophy-line'
    },
    {
      date: 'Dec 5, 2024',
      title: 'RevenantKing 20-game win streak',
      description: 'Incredible performance across multiple tournaments',
      icon: 'ri-fire-line'
    },
    {
      date: 'Nov 28, 2024',
      title: 'New regional record set',
      description: 'North America breaks 50K total points milestone',
      icon: 'ri-flag-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Season Highlights</h2>
          <p className="text-gray-400 text-lg">Outstanding achievements and memorable moments</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {achievements.map((achievement, index) => (
            <div key={index} className="bg-gray-800 rounded-xl p-6 border border-gray-700 hover:border-purple-600 transition-all cursor-pointer">
              <div className={`w-12 h-12 flex items-center justify-center bg-gray-900 rounded-lg mb-4`}>
                <i className={`${achievement.icon} text-2xl ${achievement.color}`}></i>
              </div>
              <h3 className="text-gray-400 text-sm mb-2">{achievement.title}</h3>
              <div className="text-2xl font-bold text-white mb-1">{achievement.value}</div>
              <div className="text-purple-400 font-semibold">{achievement.player}</div>
            </div>
          ))}
        </div>

        <div className="bg-gray-800 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center">
            <i className="ri-time-line text-purple-400 mr-3"></i>
            Recent Milestones
          </h3>
          
          <div className="space-y-6">
            {milestones.map((milestone, index) => (
              <div key={index} className="flex items-start space-x-4 pb-6 border-b border-gray-700 last:border-0 last:pb-0">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-600 rounded-full flex-shrink-0">
                  <i className={`${milestone.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="text-gray-400 text-sm mb-1">{milestone.date}</div>
                  <h4 className="text-white font-bold text-lg mb-2">{milestone.title}</h4>
                  <p className="text-gray-400">{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-purple-900/50 to-gray-800/50 rounded-xl p-8 border border-purple-600/30">
            <h3 className="text-2xl font-bold text-white mb-4">Want to see your name here?</h3>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
              Join Revenant League today and start your journey to the top. Compete in tournaments, climb the rankings, and become a legend.
            </p>
            <button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-sword-line mr-2"></i>
              Start Competing
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
